/**
 * Normalises an unknown thrown value into the `{ message, code }` pair the
 * error banner renders. ss-ui-client passed the raw axios error straight into
 * `ErrorBanner`, which read `error.code` / `error.message`; the useful values
 * actually live on `error.response.data`, so both shapes are checked.
 */

export type MfaErrorDetail = {
  message: string;
  code: string;
};

/** Models both an axios error (has `.response.data`) and a plain Error (top-level `.code`/`.message`). */
type MfaErrorLike = {
  code?: string | number;
  message?: string;
  response?: {
    data?: {
      code?: string | number;
      message?: string;
    };
  };
};

export const getMfaErrorDetail = (error: unknown, fallbackMessage: string): MfaErrorDetail => {
  const err = error as MfaErrorLike | null;
  const data = err?.response?.data;

  const code = data?.code ?? err?.code;
  const message = data?.message ?? err?.message;

  // An empty message must still fall back, otherwise the banner renders blank.
  const hasMessage = message != null && message !== '';

  return {
    code: code == null ? '' : String(code),
    message: hasMessage ? message : fallbackMessage,
  };
};
